<template>
  <div class="mobile-uploader">
    <canvas
      class="mobile-uploader__qrcode"
      ref="shareCode"
      :style="{ width: `${size}px`, height: `${size}px` }"
    ></canvas>
    <div class="mobile-uploader__text">
      <div>微信扫一扫</div>
      <div>手机照片直接上传</div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode';
import { hostBuild } from '@/utils/utils';
export default {
  name: 'MobileUploader',
  props: {
    // 二维码尺寸
    size: {
      type: Number,
      default: 86,
    },
    // 轮询时间间隔 毫秒
    interval: {
      type: Number,
      default: 2000,
    },
    // 二维码周围留白 px
    margin: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      // 房间号
      roomNumber: '',
      timer: null,
    };
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    /**
     * 获取房间内容
     */
    async getContent() {
      const { data } = await this.$axios.post('/media/v1/get/room/content', { roomNumber: this.roomNumber });

      if (data && data.length) {
        this.$emit('change', data);
        this.$emit('success', data);
      }

      this.timer = setTimeout(() => {
        this.getContent();
      }, this.interval);
    },
    /**
     * 初始化
     */
    async init() {
      // 获取房间号
      const { data } = await this.$axios.get('/media/v1/get/room/number');
      this.roomNumber = data;

      await this.$nextTick();

      // 生成二维码图片
      QRCode.toCanvas(
        this.$refs.shareCode,
        'https:' + hostBuild(`/mobileUpload.html?room=${this.roomNumber}`, 'editor'),
        { width: this.size, margin: this.margin },
        error => error && console.error(error),
      );

      // 如果绑定 @change 方法 进行轮询
      if (this.$listeners.change) {
        setTimeout(() => {
          this.getContent();
        }, this.interval);
      }
    },
  },
};
</script>
<style>
.mobile-uploader {
  box-sizing: border-box;
  width: 250px;
  height: 135px;
  padding: 25px 20px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mobile-uploader__text {
  font-size: 14px;
  line-height: 30px;
}
</style>
